module.exports = "/assets/listing/ginweekBannerMobile.jpg?KMYO9lR";